export default "__VITE_ASSET__9a604834__"